module.exports = __webpack_public_path__ + "img/child_login.4a426b12.svg";